import React from 'react';
import axios from 'axios';
import { authInterceptor } from './webcommon/common/httpConnection/adfsConnection';
import { routerMiddleware, ConnectedRouter, connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { compose, applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import EnvColor from './webcommon/envcolor/EnvColor';
import Modal from './webcommon/common/modal/Modal';
import App from './app/App';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
import { getVirtualDirectory } from './common/helpermethods/HelperMethods';
import { AuthProvider } from './auth/AuthContext';

axios.interceptors.request.use(authInterceptor);
axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.headers.common.Pragma = 'no-cache';
axios.defaults.baseURL = window.APP_ENV_CONFIG.API_PATH;
const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const PAGE_ROUTE = getVirtualDirectory();

if (process.env.REACT_APP_DEBUGGER_ON_START) {
    // eslint-disable-next-line no-debugger
    debugger;
}

const store = createStore(
    connectRouter(history)(rootReducer),
    {},
    composeEnhancers(
        applyMiddleware(
            routerMiddleware(history),
            sagaMiddleware
        )
    )
);

sagaMiddleware.run(rootSaga);

if (process.env.NODE_ENV !== 'test') {
    Modal.setAppElement('body');
}

render(
    <Provider store={ store }>
        <AuthProvider>
            <ConnectedRouter history={ history } basename={ PAGE_ROUTE }>
                <EnvColor env={ window.APP_ENV_CONFIG.REACT_APP_ENVIRONMENT } />
                <App />
            </ConnectedRouter>
        </AuthProvider>
    </Provider>,
    document.getElementById('root')
);
